import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GridDataResult } from "@progress/kendo-angular-grid";
import { DataResult } from "@progress/kendo-data-query";
import { BehaviorSubject, Observable } from "rxjs-compat";
import { AppConstant } from "src/app/app.constant";
import { map } from "rxjs/operators";

@Injectable()
export class PurchaseService{
    apiUrl: string;
    kendoDataUrl: string;
    constructor(private httpClient: HttpClient,
        private appConstant: AppConstant) {
        this.apiUrl = this.appConstant.getUrl()
    }
    public getAllPlanPurchaseHistory(): Observable<DataResult> {
        return this.httpClient.get(`${this.apiUrl}/getAllPlanPurchaseHistory/`).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }
}